var $e19a2d4a506edd7b$exports = {};
$e19a2d4a506edd7b$exports = {
    "pending": `ootel`
};


export {$e19a2d4a506edd7b$exports as default};
//# sourceMappingURL=et-EE.mjs.map
